import React from 'react';
import CategoriesFilter from 'components/list/Filters/types/CategoriesFilter';

const ProductCategoryIdFilter = <CategoriesFilter
    label='filters.components.categoryId.label'
    options={ {
        fullWidth: true,
        floatingLabelFixed: true,
    } }
    source='product_category_id'
/>;

export default ProductCategoryIdFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/ProductCategoryIdFilter.js